import { FecImportAnalysisErrorCode } from '../enums/fecImportAnalysisErrorCode'
import { FecImportLifecycleStatus } from '../enums/fecImportLifecycleStatus'
import type { FecImportItem } from '../query-api'
import { getFecImportAnalysisErrorCode } from './getFecImportAnalysisErrorCode'

/**
 * Whether the user can re-run the analysis instead of uploading again. The backend decides if a retry is possible
 * (`canRetry`); on top of that only failures that are not the file's fault are offered: a failed detection, or
 * anything that timed out. A file that cannot be parsed has to be replaced.
 */
export const isFecImportRetryable = (fecImport: FecImportItem): boolean =>
  fecImport.canRetry &&
  (fecImport.status === FecImportLifecycleStatus.DetectionFailed ||
    getFecImportAnalysisErrorCode(fecImport) === FecImportAnalysisErrorCode.Timeout)
